import PropTypes from "prop-types";
import React from "react";
import { changeLanguage } from "redux-multilanguage";
import {
    globalURL,
    fetchApiHeaders
} from "../../../constants";

const LanguageCurrencyChanger = ({
    currentLanguageCode,
    dispatch,
    login
}) => {
    const changeLanguageTrigger = e => {
        const languageCode = e.target.value;
        dispatch(changeLanguage(languageCode));
        if (login.user !== null) {
            fetch(globalURL + "/user/updateUserLanguage", {
                method: 'POST',
                headers: {
                    ...fetchApiHeaders.POST,
                    token: login.user.token
                },
                body: JSON.stringify({
                    language: languageCode
                })
            })
        }
    };

    return (
        <div className="language-currency-wrap">
            <div className="same-language-currency language-style">
                <span>
                    {currentLanguageCode === "tr"
                        ? "Türkçe"
                        : currentLanguageCode === "eng"
                            ? "English"
                            : ""}{" "}
                    <i className="fa fa-angle-down" />
                </span>
                <div className="lang-car-dropdown">
                    <ul>
                        <li>
                            <button value="tr" onClick={e => changeLanguageTrigger(e)}>
                                Türkçe
                            </button>
                        </li>
                        <li>
                            <button value="eng" onClick={e => changeLanguageTrigger(e)}>
                                English
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

LanguageCurrencyChanger.propTypes = {
    currentLanguageCode: PropTypes.string,
    dispatch: PropTypes.func
};

export default LanguageCurrencyChanger;
